import { createSelector } from 'reselect'

export const getErrorMessage = createSelector(
  state => (state && state.checkRegistrationCost ? state.checkRegistrationCost.error : null),
  errorMessage => errorMessage
)
